import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { SofaPanel, SofaFormControl, SofaLink } from '@sofology/sofologycomponents';

import './FinanceBankDetailsForm.scss';

import { SofaFormComponent } from 'interfaces';
import { PropertyValueType, SofaFormType, componentGeneratorHelper, formGeneratorHelper } from 'helpers/dynamicFormHelpers';
import { IlpQuestionDescriptions, IfcApplicationData, SofaFormCrossValidationHandlerType } from 'models';

const BANK_FORM_KEY = 'bank';

interface OwnProps {
    ifcQuestionSet: IlpQuestionDescriptions;
    ifcApplicationData: IfcApplicationData;
    ref?: React.RefObject<FinanceBankDetailsFormType>;
    onGoToStartCheckout: () => void;
    onDynamicFormInitialized: () => void;
}

interface OwnState {
    bankForm: SofaFormType;
    proccessFormCrossValidation: SofaFormCrossValidationHandlerType;
    formHasInvalidReadonlyControls: boolean;
}

class FinanceBankDetailsForm extends Component<OwnProps, OwnState> implements SofaFormComponent<Record<string, PropertyValueType>> {
    constructor(props: OwnProps) {
        super(props);
        let bankFormAndHandler = formGeneratorHelper.createSofaForm(
            'bankForm',
            this.props.ifcQuestionSet[BANK_FORM_KEY].properties,
            (updateStateFunc: any) => this.setState(updateStateFunc),
            () => this.state,
            this.props.ifcApplicationData
        );

        this.state = {
            bankForm: bankFormAndHandler.form,
            formHasInvalidReadonlyControls: false,
            proccessFormCrossValidation: bankFormAndHandler.crossValidationHandler
        };
    }

    componentDidMount(): void {
        formGeneratorHelper.validateReadonlyControls(this.props.ifcQuestionSet[BANK_FORM_KEY].properties, this.state.bankForm)
            .then(invalidControls => {
                if (invalidControls.length) {
                    this.setState({ formHasInvalidReadonlyControls: true }, () => {
                        this.props.onDynamicFormInitialized();
                    });
                }
            }).catch();
    }

    componentDidUpdate(prevProps: Readonly<OwnProps>, prevState: Readonly<OwnState>): void {
        this.state.proccessFormCrossValidation(prevState, this.state);
    }

    render(): JSX.Element {
        const { ifcQuestionSet, ifcApplicationData } = this.props;
        const { formHasInvalidReadonlyControls } = this.state;
        const bankFieldSet = ifcQuestionSet[BANK_FORM_KEY];

        let formComponents: JSX.Element[] = [];

        if (this.state.bankForm) {
            formComponents = componentGeneratorHelper.getComponents(this.state.bankForm, bankFieldSet.properties, ifcApplicationData);
        }

        return (
            <div className='finance-bank-details-form'>
                <SofaPanel>
                    <div className='validation-scroll-container'>
                        {formHasInvalidReadonlyControls && this.renderInvalidReadonlytFieldMessage()}
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <h6 className='finance-bank-details-form__title'>
                                    {bankFieldSet.legend}
                                </h6>
                            </Grid>
                            {formComponents}
                        </Grid>
                    </div>
                </SofaPanel>
            </div>
        );
    }

    renderInvalidReadonlytFieldMessage(): JSX.Element {
        return (
            <Grid item xs={12}>
                <div className='finance-bank-details-form__readonly-fields-error'>
                    Previously saved information is missing mandatory fields or contains invalid characters.
                    <SofaLink onClick={this.props.onGoToStartCheckout} text='Please go back and enter manually' />
                </div>
            </Grid>
        );
    }

    public validate = (): Promise<SofaFormControl<Record<string, PropertyValueType>>[]> => {
        return this.state.bankForm.validate();
    };

    public getFormData = (): Record<string, PropertyValueType> => {
        return formGeneratorHelper.extractFormDataToIlpObject(
            this.state.bankForm,
            this.props.ifcQuestionSet[BANK_FORM_KEY].properties);
    };

    public hasInvalidReadonlyControls = (): boolean => {
        return this.state.formHasInvalidReadonlyControls;
    };
}

export default FinanceBankDetailsForm;
export type FinanceBankDetailsFormType = FinanceBankDetailsForm;